import React from 'react';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';

type Props = {
  text: string | number;
  badgeTextClasses?: Argument;
};
export const BadgeText: React.FC<Props> = ({ text, badgeTextClasses }) => (
  <span className={cs('bbk-badge-text', badgeTextClasses)}>{text}</span>
);
